import * as contentful from 'contentful';

export const CONTENTFUL_CLIENT = contentful.createClient({

    space: 'sjqkiwsta3ek',
    accessToken: 'P7SmtvQO-CBQJZMDYSy9SxrqVkGZHq3QOGxTiw-pSBY',
});